
import { Component, Prop, Vue } from "vue-property-decorator";
import GuncellemelerDialog, {
  UpdateItem,
  Severity
} from "@/components/infos/GuncellemelerDialog.vue";

const API = {
  LIST: "https://zirve-bilgisayar.com/ajax/duyurular",
  MARK_READ: "",     // TODO: Mark read endpoint if needed
  UNREAD_COUNT: ""   // TODO: Unread count endpoint if needed
};

@Component({
  components: { GuncellemelerDialog }
})
export default class GuncellemelerInfo extends Vue {
  dialog = false;
  items: UpdateItem[] = [];
  loading = false;
  unreadCount = 0;
  pollId: number | null = null;

  /** butona basınca */
  openDialog() {
    this.dialog = true;
    if (!this.items.length) this.fetchUpdates();
  }

  /** GENEL YÜKLEYİCİ */
  async fetchUpdates() {
    this.loading = true;
    try {
      const response = await this.$http.get(API.LIST);
      // Axios interceptor may unwrap the data, so check both response.data and response itself
      const data = Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : []);

      // Transform API response to UpdateItem format
      this.items = data.map((item: any) => {
        // Parse duyuru_type JSON string to extract tags
        let tags: string[] = [];
        try {
          const typeArray = JSON.parse(item.duyuru_type);
          tags = typeArray.map((t: any) => t.id.text);
        } catch (e) {
          tags = [];
        }

        // Parse product JSON string to extract product names and IDs
        let products: Array<{text: string; value: number}> = [];
        try {
          const productArray = JSON.parse(item.product);
          products = productArray.map((p: any) => ({
            text: p.id.text,
            value: p.id.value
          }));
        } catch (e) {
          products = [];
        }

        return {
          id: item.duyuru_id,
          title: item.duyuru_baslik,
          content: item.duyuru_metin,
          createdAt: this.$helper.tarihSaatStr(item.duyuru_tarih) ,
          severity: "info" as Severity, // Default severity, adjust if needed
          read: false, // Default to unread, adjust if API provides read status
          tags: tags,
          products: products
        };
      });

      this.unreadCount = this.items.filter(i => !i.read).length;
    } catch (e) {
      console.warn("Güncellemeler getirilemedi:", e);
      this.items = [];
      this.unreadCount = 0;
    } finally {
      this.loading = false;
    }
  }

  async markRead(id: string) {
    // API varsa:
    // if (API.MARK_READ) await fetch(API.MARK_READ.replace(":id", id), { method: "POST", credentials: "include" });
    const idx = this.items.findIndex(i => i.id === id);
    if (idx !== -1) this.$set(this.items, idx, { ...this.items[idx], read: true });
    this.unreadCount = this.items.filter(i => !i.read).length;
  }

  async markAllRead() {
    // API varsa:
    // if (API.MARK_READ_ALL) await fetch(API.MARK_READ_ALL, { method: "POST", credentials: "include" });
    this.items = this.items.map(i => ({ ...i, read: true }));
    this.unreadCount = 0;
  }

  /** Periyodik kontrol – 5 dk'da bir */
  mounted() {
    this.fetchUpdates();
  }

  beforeDestroy() {
    if (this.pollId) clearInterval(this.pollId);
  }
}
